module.exports = __webpack_public_path__ + "img/56.2.TN.6359dba5.png";